import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import VideoCanvas from './VideoCanvas';
import VideoStreamComponent from './VideoStreamComponent';
import StreamStatsPanel from './StreamStatsPanel';
  

// const VehicleStats = ({ stats }) => {
//   if (!stats) return null;
  
//   return (
//     <div className="vehicle-stats-overlay">
//       <div className="stat-item in">
//         <span className="stat-label">Vehicles IN:</span>
//         <span className="stat-value">{stats.vehicles_in}</span>
//       </div>
//       <div className="stat-item out">
//         <span className="stat-label">Vehicles OUT:</span>
//         <span className="stat-value">{stats.vehicles_out}</span>
//       </div>
//       <div className="stat-item total">
//         <span className="stat-label">Total:</span>
//         <span className="stat-value">{stats.total_vehicles}</span>
//       </div>
//       <div className="stat-item location">
//         <span className="stat-value">{stats.location}</span>
//       </div>
//     </div>
//   );
// };
const LOCATIONS = {
  'Kuju': [
    "Kuya Entry Exit 12/13",
    "Kuya 14/16 Coal Dump (DDU) Entry Exit Gate",
    "Ghanudih Enty Exit",
    "Bastacolla OCP Entry Exit Gate Porta Cabin",
    "Kuya 12/13 Entry Exit Gate near Kujama",
    "Rajapur Entry/Exit Gate",
    "Buragarh Railway Siding Entry / Exit Gate",
  ],

  


};
const LOCATION_CAMERA_IPS = {
  "Kuya Entry Exit 12/13": [
    "172.16.12.25",
    "172.16.12.197"
  ],
  "Kuya 14/16 Coal Dump (DDU) Entry Exit Gate": [
    "172.16.12.97",
    "172.16.12.96"
  ],
  "Ghanudih Enty Exit": [
    "172.16.12.125",
    "172.16.12.127"
  ],
  "Bastacolla OCP Entry Exit Gate Porta Cabin": [
    "172.16.12.111"
  ],
  "Kuya 12/13 Entry Exit Gate near Kujama": [
    "172.16.12.112",
    "172.16.12.113"
  ],
  "Rajapur Entry/Exit Gate": [
    "172.16.12.81",
    "172.16.12.82"
  ],
  "Buragarh Railway Siding Entry / Exit Gate": [
    "172.16.12.190",
    "172.16.12.191"
  ],

  
  "LODNA/BHAGA CHECKPOST": [
    "172.16.8.34",
    "172.16.8.35",
    "172.16.8.36",
    "172.16.8.109",
    "172.16.8.111",
    "172.16.8.112",
    "172.16.8.113"
   
],

"JoyRampur Checkpost Entry/Exit": [
    "172.16.8.63",
    "172.16.8.64",
    "172.16.8.65" 
],

"Kujama CheckPost Entry/Exit": [
  "172.16.8.23",
  "172.16.8.24",
  "172.16.8.25",
  "172.16.8.26",
  "172.16.8.76",
  "172.16.8.77",
  "172.16.8.78"
],
"BASDEOPUR COAL DUMP CHECKPOST": [
  "172.16.4.100",
  "172.16.4.101",
  "172.16.4.102",
  "172.16.4.103",
  "172.16.4.104",
  "172.16.4.105"
 
],
"MODIDIH CHECK POST PORTA CABIN": [
  "172.16.4.146",
  "172.16.4.147",
  "172.16.4.148",
  "172.16.4.149",
  "172.16.4.150",
  "172.16.4.151"
],
"SENDRA BANSJORA MINE ENTRY/EXIT CHECKPOST": [
  "172.16.4.139",
  "172.16.4.140",
  "172.16.4.141",
  "172.16.4.142",
  "172.16.4.143",
  "172.16.4.144"
],
"TETULMARI CHECK POST":[
  "172.16.4.132",
  "172.16.4.133",
  "172.16.4.134",
  "172.16.4.135",
  "172.16.4.136",
  "172.16.4.137"

],
 "KANKANI PATCH-B ENTRANCE":[
  "172.16.4.5",
  "172.16.4.6",
  "172.16.4.7"

],
"KANKANI MINE ENTRY/EXIT CHECKPOST":[
  "172.16.4.87",
  "172.16.4.87",
  "172.16.4.115",
  "172.16.4.117",
  "172.16.4.118",
  "172.16.4.119",
  "172.16.4.120",
  "172.16.4.121"

],
"KANKANI COAL DUMP  ENTRY/EXIT  CHECK POST":[

  "172.16.4.123",
  "172.16.4.124",
  "172.16.4.125"
],

'DHANSAR CISF CHECK POST NEAR DHANSAR WORKSHOP MAIN GATE': [
    '172.16.16.12',
    '172.16.16.13',
    '172.16.16.14',
    '172.16.16.15',
    '172.16.16.16'
  ],
  'ENA CISF CHECK POST': [
    '172.16.16.20',
    '172.16.16.21',
    '172.16.16.22',
  ],
  'ALKUSA CISF CHECK POST': [
    '172.16.16.29',
    '172.16.16.30',
    '172.16.16.31',
    '172.16.16.32',
    '172.16.16.114'
  ],
  'GODHAR 15 NO. CISF CHECK POST': [
    '172.16.16.44',
    '172.16.16.45',
    '172.16.16.46',
    '172.16.16.48'
  ],
  'INDIRA CHOWK': [
    '172.16.16.150',
    '172.16.16.151',
    '172.16.16.154'
  ],
  // 'KDSK RAILWAY SIDING CISF CHECK POST': [
  //   '172.16.16.122',
  //   '172.16.16.123',
  //   '172.16.16.125'
  // ],
  // 'KKC LINK CISF CHECK POST NEAR TALAB': [
  //   '172.16.16.130',
  //    '172.16.16.131',
  //    '172.16.16.132',
  //    '172.16.16.133'
  // ],
  'KDS-II RAILWAY SIDING CISF CHECK POST NEAR CULVAT': [
    '172.16.16.164',
    '172.16.16.165',
    '172.16.16.166',
    '172.16.16.167'
  ],
  "KANTAPAHADI ENTRY/ EXIT": [
    "172.16.0.69",
    "172.16.0.70",
    "172.16.0.71"

],
"SIJUA SIDING EXIT GATE": [
    "172.16.0.142",
    "172.16.0.143",
    "172.16.0.144",
    "172.16.0.145",
    "172.16.0.146"
],
  "SIJUA SIDING ENTRY GATE":[
    "172.16.0.51",
    "172.16.0.52",
    "172.16.0.53"

  ],
    "CHETUDIH CHECKPOST (ENTRY/EXIT)":[
        "172.16.0.125",
        "172.16.0.126",
        "172.16.0.127",
        "172.16.0.128",
        "172.16.0.129"
    ],

    "PARKING YARD CHECKPOST":[
        "172.16.0.157",
        "172.16.0.158",
        "172.16.0.159",
        "172.16.0.185",
        "172.16.0.186"
    ]




};
const CAMERA_NAMES = {
  "172.16.12.25": "CAM 1",
  "172.16.12.27": "CAM 2",
  "172.16.12.196": "CAM 3",
  "172.16.12.197": "CAM 4",
  "172.16.16.26": "CAM 2",
  "172.16.16.28": "CAM 2",
  "172.16.12.198": "CAM 5",
  "172.16.12.97": "CAM 1",
  "172.16.12.95": "CAM 2",
  "172.16.12.96": "CAM 3",
  "172.16.12.128": "CAM 1",
  "172.16.12.109": "CAM 1",
  "172.16.12.110": "CAM 2",
  "172.16.12.111": "CAM 3",
  "172.16.12.112": "CAM 1",
  "172.16.12.113": "CAM 2",
  "172.16.12.114": "CAM 3",
  "172.16.12.81": "CAM 1",
  "172.16.12.82": "CAM 2",
  "172.16.12.83": "CAM 3",
  "172.16.12.190": "CAM 1",
  "172.16.12.191": "CAM 2",
  "172.16.12.192": "CAM 3",
  "172.16.8.34": "CAM 1",
  "172.16.8.35": "CAM 2",
  "172.16.8.109": "CAM 3",
  "172.16.8.111": "CAM 4",
  "172.16.8.112": "CAM 5",
  "172.16.8.113": "CAM 5",
  "172.16.8.63": "CAM 1",
  "172.16.8.64": "CAM 2",
  "172.16.8.65": "CAM 3",
  "172.16.8.23": "CAM 1",
  "172.16.8.24": "CAM 2",
  "172.16.8.25": "CAM 3",
  "172.16.8.26": "CAM 4",
  "172.16.8.76": "CAM 5",
  "172.16.8.77": "CAM 5",
  "172.16.8.78": "CAM 5",
  "172.16.4.100": "CAM 1",
  "172.16.4.101": "CAM 2",
  "172.16.4.102": "CAM 3",
  "172.16.4.103": "CAM 4",
  "172.16.4.104": "CAM 5",
  "172.16.4.105": "CAM 6",
  "172.16.4.146": "CAM 1",
  "172.16.4.147": "CAM 2",
  "172.16.4.148": "CAM 3",
  "172.16.4.149": "CAM 4",
  "172.16.4.150": "CAM 5",
  "172.16.4.151": "CAM 6",
  "172.16.4.139": "CAM 1",
  "172.16.4.140": "CAM 2",
  "172.16.4.141": "CAM 3",
  "172.16.4.142": "CAM 4",
  "172.16.4.143": "CAM 5",
  "172.16.4.144": "CAM 6",
  "172.16.4.132": "CAM 1",
  "172.16.4.133": "CAM 2",
  "172.16.4.134": "CAM 3",
  "172.16.4.135": "CAM 4",
  "172.16.4.136": "CAM 5",
  "172.16.4.137": "CAM 6",
  "172.16.4.5": "CAM 1",
  "172.16.4.6": "CAM 2",
  "172.16.4.7": "CAM 3",
  "172.16.4.87": "CAM 1",
  "172.16.4.88": "CAM 2",
  "172.16.4.115": "CAM 3",
  "172.16.4.117": "CAM 4",
  "172.16.4.118": "CAM 5",
  "172.16.4.119": "CAM 6",
  "172.16.4.120": "CAM 7",
  "172.16.4.121": "CAM 8",
  "172.16.4.123": "CAM 1",
  "172.16.4.124": "CAM 2",
  "172.16.4.125": "CAM 3",
  "172.16.16.12": "CAM 1",
   "172.16.16.13": "CAM 2",
   "172.16.16.14": "CAM 3",
   "172.16.16.15": "CAM 4",
   "172.16.16.16": "CAM 5",
  "172.16.16.20": "CAM 1",
   "172.16.16.21": "CAM 2",
   "172.16.16.22": "CAM 3", 
  "172.16.16.23": "CAM 4",
   "172.16.16.101": "CAM 5",
  "172.16.16.29": "CAM 1",
   "172.16.16.30": "CAM 2",
   "172.16.16.31": "CAM 3", 
  "172.16.16.32": "CAM 4",
   "172.16.16.114": "CAM 5",
  "172.16.16.44": "CAM 1", 
  "172.16.16.45": "CAM 2", 
  "172.16.16.46": "CAM 3",
   "172.16.16.47": "CAM 4",
   "172.16.16.48": "CAM 5",
  "172.16.16.150": "CAM 1",
   "172.16.16.151": "CAM 2",
   "172.16.16.152": "CAM 3",
   "172.16.16.153": "CAM 4",
   "172.16.16.154": "CAM 5",
  "172.16.16.122": "CAM 1", 
  "172.16.16.123": "CAM 2",
   "172.16.16.125": "CAM 3",
  "172.16.16.130": "CAM 1", 
  "172.16.16.131": "CAM 2",
   "172.16.16.132": "CAM 3",
   "172.16.16.133": "CAM 4",
  "172.16.16.163": "CAM 1",
   "172.16.16.164": "CAM 2",
   "172.16.16.165": "CAM 3",
   "172.16.16.166": "CAM 4",
   "172.16.16.167": "CAM 5",
   "172.16.0.69":"CAM 1",
   "172.16.0.70":"CAM 2",
   "172.16.0.71":"CAM 3", 
   "172.16.0.142":"CAM 1",
   "172.16.0.143":"CAM 2",
   "172.16.0.144":"CAM 3",
   "172.16.0.145":"CAM 4",
   "172.16.0.146":"CAM 5",
   "172.16.0.55":"CAM 1",
   "172.16.0.56":"CAM 2",
   "172.16.0.57":"CAM 3",
   "172.16.0.109":"CAM 4",
   "172.16.0.51":"CAM 1",
   "172.16.0.52":"CAM 2",
   "172.16.0.53":"CAM 3",
   "172.16.0.125":"CAM 1",
   "172.16.0.126":"CAM 2",
   "172.16.0.127":"CAM 3",
   "172.16.0.128":"CAM 4",
   "172.16.0.129":"CAM 5",
   
   "172.16.0.157":"CAM 1",
   "172.16.0.158":"CAM 2",
   "172.16.0.159":"CAM 3",
   "172.16.0.185":"CAM 4",
   "172.16.0.186":"CAM 5"


   

  
};
const BASE_URL = {
  "Kuju": "https://202.140.131.122:8765",
  
};

function ReportFilterModal({}) {
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedCamera, setSelectedCamera] = useState('');
  const [availableLocations, setAvailableLocations] = useState([]);
  const [availableCameras, setAvailableCameras] = useState([]);
  const [isStreaming, setIsStreaming] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const [streamStats, setStreamStats] = useState(null);
  const statsTimerRef = useRef(null);

  useEffect(() => {
    if (selectedArea) {
      setAvailableLocations(LOCATIONS[selectedArea] || []);
      setSelectedLocation('');
      setSelectedCamera('');
      setAvailableCameras([]);
    }
  }, [selectedArea]);

  useEffect(() => {
    if (selectedLocation) {
      const cameraIps = LOCATION_CAMERA_IPS[selectedLocation] || [];
      setAvailableCameras(cameraIps);
      setSelectedCamera('');
    }
  }, [selectedLocation]);

  useEffect(() => {
    return () => {
      if (statsTimerRef.current) {
        clearInterval(statsTimerRef.current);
      }
      stopStream();
    };
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      if (!selectedCamera || !selectedArea) return;
      const baseUrl = BASE_URL[selectedArea];
      try {
        const statsResponse = await axios.get(`${baseUrl}/stream-stats/${selectedCamera}`);
        setStreamStats(statsResponse.data);
      } catch (error) {
        console.error("Error fetching stream stats:", error);
      }
    };
    fetchStats();
  }, [selectedCamera]);

  const handleAreaChange = (e) => {
    stopStream();
    setSelectedArea(e.target.value);
  };

  const handleLocationChange = (e) => {
    stopStream();
    setSelectedLocation(e.target.value);
  };

  const handleCameraChange = (e) => {
    stopStream();
    setSelectedCamera(e.target.value);
  };

  const startStream = async () => {
    if (!selectedCamera || !selectedArea) return;

    try {
      const baseUrl = BASE_URL[selectedArea];
      if (!baseUrl) {
        alert("Invalid area selected. Please try again.");
        return;
      }

      const response = await axios.post(`${baseUrl}/start-stream`, {
        camera_ip: selectedCamera
      });
      setStreamUrl(`${baseUrl}${response.data.stream_url}`);
      setIsStreaming(true);

      statsTimerRef.current = setInterval(async () => {
        try {
          const statsResponse = await axios.get(`${baseUrl}/stream-stats/${selectedCamera}`);
          setStreamStats(statsResponse.data);
        } catch (error) {
          console.error("Error fetching stream stats:", error);
        }
      }, 10000);
    } catch (error) {
      console.error("Error starting stream:", error);
      alert("Failed to start stream. Please try again.");
    }
  };

  const stopStream = async () => {
    if (!isStreaming) return;

    try {
      const baseUrl = BASE_URL[selectedArea];
      if (!baseUrl) {
        alert("Invalid area selected. Please try again.");
        return;
      }
      const response = await axios.post(`${baseUrl}/stop-stream`, {
        camera_ip: selectedCamera
      });
      //console.log("Stream stopped:", response.data);
    } catch (error) {
      console.error("Error stopping stream:", error);
      alert("Failed to stop stream. Please try again.");
    } finally {
      setIsStreaming(false);
      setStreamUrl('');
      setStreamStats(null);
      if (statsTimerRef.current) {
        clearInterval(statsTimerRef.current);
      }
    }
  };

  return (
    <div className="App">
      <div className="controls-container">
        <div className="dropdown-container">
          <div className="dropdown-group" style={{ display: 'flex', gap: '22rem', alignItems: 'center' }}>
            <div className="dropdown-item" style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="area-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Area:</label>
              <select id="area-select" className='area-select' value={selectedArea} onChange={handleAreaChange} disabled={isStreaming}>
                <option value="">Select Area</option>
                {Object.keys(BASE_URL).map(area => (
                  <option key={area} value={area}>{area}</option>
                ))}
              </select>
            </div>

            <div className="dropdown-item" style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="location-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Location:</label>
              <select id="location-select" className='location-select' value={selectedLocation} onChange={handleLocationChange} disabled={!selectedArea || isStreaming}>
                <option value="">Select Location</option>
                {availableLocations.map(location => (
                  <option key={location} value={location}>{location}</option>
                ))}
              </select>
            </div>

            <div className="dropdown-item" >
              <label htmlFor="camera-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Camera:</label>
              <select id="camera-select" className='camera-select' value={selectedCamera} onChange={handleCameraChange} disabled={!selectedLocation || isStreaming}>
                <option value="">Select Camera</option>
                {availableCameras.map(ip => (
                  <option key={ip} value={ip}>{CAMERA_NAMES[ip] || 'Camera'} ({ip})</option>
                ))}
              </select>
            

            
              {!isStreaming ? (
                <button className="start-btn" style={{ height: '40px' , width:'40px' }} onClick={startStream} disabled={!selectedCamera}>Start Stream</button>
              ) : (
                <button className="stop-btn" onClick={stopStream}>Stop Stream</button>
              )}
            
            </div>
          </div>
        </div>
      </div>

      <div className="stream-container" style={{ width: '70%', height: '70%', margin: 'auto' }}>
        {isStreaming ? (
          <div className="video-container" style={{ width: '100%', height: '100%', maxHeight: '400px' }}>
            <VideoStreamComponent streamUrl={streamUrl} />
          </div>
        ) : (
          <div className="stream-placeholder" style={{ width: '100%', height: '300px' }}>
            <div className="placeholder-text">
              Select a camera and click "Start Stream" to begin monitoring
            </div>
          </div>
        )}
      </div>

      <StreamStatsPanel stats={streamStats} />
    </div>
  );
}

export default ReportFilterModal;
